import { DayPreference } from './day-preference.model';
import { TruckTypePreference } from './truck-type-preference.model';

export class Preferences {
  id: string;
  loadWeightPreference?: string;
  maxDeadheadMiles?: string;
  favouriteLaneOrigin?: string;
  favouriteLaneOriginCity?: string;
  favouriteLaneOriginState?: string;
  favouriteLaneDestination?: string;
  favouriteLaneDestinationCity?: string;
  favouriteLaneDestinationState?: string;
  earningType?: string;
  trailerType?: string;
  baseLocation?: string;
  baseLocationCity?: string;
  baseLocationState?: string;
  crossBorder?: string;
  usZone?: string;
  daysAwayFromBaseLocation?: string;
  truckType?: any;
}
